// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { FormFieldProps } from 'lib/forms';
import { PlaceholdersData } from '@sitecore-jss/sitecore-jss/layout';
export type ComponentContainerProps =
  Feature.EnterpriseWeb.RenewalByAndersen.Forms.Fields.ComponentContainer &
    FormFieldProps & { placeholders: PlaceholdersData<string> };

const ComponentContainer = (props: ComponentContainerProps) => {
  return (
    <div className="component-container col-span-12">
      <Placeholder
        name="components"
        rendering={{
          dataSource: 'manually-passed',
          componentName: 'ComponentContainer',
          placeholders: props.placeholders,
        }}
        render={(components) => {
          return components.map((component, index) => <div key={index}>{component}</div>);
        }}
      />
    </div>
  );
};
export default ComponentContainer;
